<template functional>
  <el-tag :type="$options.checkType(props.row[props.column])"
    >{{ props.row[props.column] }}
  </el-tag>
</template>
<script>
export default {
  name: "SuperTagHelper",
  props: {
    row: Object,
    column: String,
    tagType: String,
    tagValue: [String, Number]
  },
  checkType(value) {
    //implemente la logica de tareas cerradas tarde, pendiente, realizadas y Retrasadas en los status
    if (value === "Abierta Retrasada") {
      return "danger";
    } else if (value === "Pendiente") {
      return "warning";
    } else if (value === "Cerrada a Tiempo") {
      return "success";
    } else if (value === "Cerrada Retrasada") {
      return "danger";
    } else if (value === "Abierta a Tiempo") {
      return "warning";
    }

    //console.log("value: ", value);
    //value !== null? value :  value = "Cerrada a Tiempo"
  }
};
</script>
